import React, {useEffect, useState} from "react";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import {useSelector} from "react-redux";

const SelectedBooking = ({
                           editable,
                           setEditable,
                           calendarRef,
                           booking,
                           setSelectedBooking
                         }) => {
  const tagOwnersUrl = useSelector(state => state.meeting_calendar?.tag_owners_url)
  const removeBookingUrl = useSelector(state => state.meeting_calendar?.remove_booking_url)
  const [loading, setLoading] = useState(true)
  const [availabilities, setAvailabilities] = useState([])

  useEffect(() => {
    axios.post(tagOwnersUrl, {
      start: booking?.start,
      end: booking?.end,
    }).then(response => {
      if (response.data.availabilities) {
        setAvailabilities(response.data.availabilities)
      }
    }).catch((error) => {
      console.error(error)
      alert(error.response?.data?.message || error)
    }).finally(() => {
      setLoading(false)
    })
  }, [booking])

  const handleRemoveBookingClicked = () => {
    if (confirm("Are you sure?")) {
      setEditable(false)
      const url = removeBookingUrl
        .replaceAll("__start__", encodeURIComponent(booking.start.toISOString()))
        .replaceAll("__end__", encodeURIComponent(booking.end.toISOString()))
      axios.delete(url).catch((error) => {
        console.error(error)
        alert(error.response?.data?.message || error)
      }).finally(() => {
        if (calendarRef.current) {
          const api = calendarRef.current.getApi()
          api.refetchEvents()
        }
        setSelectedBooking(null)
        setEditable(true)
      })
    }
  }

  if (loading) {
    return <div className={"py-4 text-center"}><i className="fa fa-spinner fa-spin"/> Loading ... </div>
  }

  return <div className={"row"}>
    <div className="col-12 p-4">
      {(!availabilities || availabilities.length === 0) && <div className="alert alert-primary">
        No bookings
      </div>}
      <div className={"list-group"}>
        {availabilities.map(availability => {
          return <div className={"list-group-item list-group-item-action flex-column align-items-start"}>
            <p className={"mb-1"}>
              {availability.begins_at} - {availability.ends_at}
            </p>
            <small className="text-muted">{availability.name}</small>
          </div>
        })}
      </div>
      <hr/>
      <div className="text-right">
        <button
          disabled={!editable}
          onClick={handleRemoveBookingClicked}
          className="m-2 btn btn-danger"
          type={"button"}>
          Delete
        </button>
      </div>
    </div>
  </div>
}

export default SelectedBooking